export const isVimeoUrl = (url: string): boolean => {
    try {
        const parsed = new URL(url);
        return parsed.hostname === 'vimeo.com' || parsed.hostname.endsWith('.vimeo.com');
    } catch (e) {
        return false;
    }
};
